import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { Route, RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const RedirectLegacyCopyPageLoader: LoadableType<Route & RouteMatch> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RedirectLegacyCopyPage" */ './RedirectLegacyCopyPage.tsx'
			)
		).RedirectLegacyCopyPage,
});

(RedirectLegacyCopyPageLoader as any).NAVIGATION_PARAMS = () => false;
